import { MessageDescriptor } from "@lingui/core";
import { msg } from "@lingui/macro";

import { TransportationCode } from "./__generated__/ProfileUpdateFormQueryRendererQuery.graphql";

export type useFormProps = {
  firstName: string;
  lastName: string;
  email: string | null;
  phoneNumber: string;
};

export type ImageObjectStateProps = {
  publicId?: string;
  provider?: string;
  imagekitFileId?: string;
  imagekitPath?: string;
  renderingBaseUrl?: string;
  height: number;
  width: number;
  format: string;
};

export type TransportationTypeProps = {
  code: TransportationCode | null | undefined;
  name: string | null;
  customCode?: string | null;
  default: boolean;
  id: string;
  memberGroups?: { id?: string }[];
};

export type PreferredTransportationTypesProps = {
  departmentId: string;
  code: TransportationCode | null | undefined;
  name: string | null;
  default: boolean;
  id: string;
  customCode?: string | null;
  memberGroups?: { id?: string }[];
  departmentName?: string;
}[];

export const ERROR_MESSAGES: Record<string, MessageDescriptor> = {
  phoneNumber: msg`Please enter a valid phone number`,
  firstName: msg`Please enter a valid name`,
  lastName: msg`Please enter a valid name`,
  email: msg`Please enter a valid email`,
};

export const FIELD_MAP: any = {
  phone_number: "phoneNumber",
  first_name: "firstName",
  last_name: "lastName",
  email: "email",
};
